/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioHusap } from './pages'

type TIdToPageMap = Record<PageIdStylioHusap, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_HUSAP: TIdToPageMap = {
  [PageIdStylioHusap.AGE_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/AgeQuestion'),
  },
  [PageIdStylioHusap.SHOP_SMARTER_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/shop-smarter/ShopSmarter').then(
        (m) => ({
          default: m.ShopSmarter,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/shop-smarter/ShopSmarter'),
  },
  [PageIdStylioHusap.HAIR_COLOR_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioHusap.WARDROBE_COLORS_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/WardrobeColorsQuestion'
      ).then((m) => ({
        default: m.WardrobeColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/WardrobeColorsQuestion'
      ),
  },
  [PageIdStylioHusap.EYES_COLOR_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioHusap.SKIN_COLOR_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/SkinColorQuestion'
      ).then((m) => ({
        default: m.SkinColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/SkinColorQuestion'),
  },
  [PageIdStylioHusap.CLIMAT_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/questions/ClimatQuestion').then(
        (m) => ({
          default: m.ClimatQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/ClimatQuestion'),
  },
  [PageIdStylioHusap.BODY_SHAPE_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioHusap.STYLIO_TO_HELP_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/StylioToHelp'),
  },
  [PageIdStylioHusap.MAIN_GOAL_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/MainGoalQuestion'
      ).then((m) => ({
        default: m.MainGoalQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/MainGoalQuestion'),
  },
  [PageIdStylioHusap.WHERE_TO_SHOP_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/WhereToShopQuestion'
      ).then((m) => ({
        default: m.WhereToShopQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/WhereToShopQuestion'),
  },
  [PageIdStylioHusap.WARDROBE_PERCENTAGE_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/WardrobePercentageQuestion'
      ).then((m) => ({
        default: m.WardrobePercentageQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/WardrobePercentageQuestion'
      ),
  },
  [PageIdStylioHusap.URGE_2_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioHusap.URGE_3_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioHusap.URGE_9_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant9').then(
        (m) => ({
          default: m.UrgePageVariant9,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant9'),
  },
  [PageIdStylioHusap.URGE_4_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioHusap.URGE_7_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant7').then(
        (m) => ({
          default: m.UrgePageVariant7,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant7'),
  },
  [PageIdStylioHusap.URGE_8_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant8').then(
        (m) => ({
          default: m.UrgePageVariant8,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/urge/UrgePageVariant8'),
  },
  [PageIdStylioHusap.STYLE_DRAWN_TO_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/StyleDrawnToQuestion'
      ).then((m) => ({
        default: m.StyleDrawnToQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/StyleDrawnToQuestion'),
  },
  [PageIdStylioHusap.OUTFIT_EMOTION_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/DressedWantQuestion'
      ).then((m) => ({
        default: m.DressedWantQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/DressedWantQuestion'),
  },
  [PageIdStylioHusap.NOTHING_TO_WEAR_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioHusap.ARCHETYPE_INTRO_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/archetype/ArchetypeIntro').then(
        (m) => ({
          default: m.ArchetypeIntro,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/archetype/ArchetypeIntro'),
  },
  [PageIdStylioHusap.LOOKING_FEMININE_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/LookingFeminineQuestion'
      ).then((m) => ({
        default: m.LookingFeminineQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/LookingFeminineQuestion'
      ),
  },
  [PageIdStylioHusap.STYLES_FEEL_LIKE_YOU_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioHusap.TALL_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/TallQuestion'),
  },
  [PageIdStylioHusap.WEIGHT_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/questions/WeightQuestion').then(
        (m) => ({
          default: m.WeightQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/WeightQuestion'),
  },
  [PageIdStylioHusap.WARDROBE_CHANGED_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/WardrobeChangedQuestion'
      ).then((m) => ({
        default: m.WardrobeChangedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/WardrobeChangedQuestion'
      ),
  },
  [PageIdStylioHusap.FAVORITE_COLORS_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_11_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant11Husap'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11Husap,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant11Husap'
      ),
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_14_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant14Husap'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Husap,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant14Husap'
      ),
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_15_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant15Husap'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Husap,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant15Husap'
      ),
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_18_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant18Husap'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Husap,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant18Husap'
      ),
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_19_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant19Husap'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Husap,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/likeOrDislike/LikeOrDislikeVariant19Husap'
      ),
  },
  [PageIdStylioHusap.WALK_INTO_ROOM_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/RelationshipStatusQuestion'
      ).then((m) => ({
        default: m.RelationshipStatusQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/RelationshipStatusQuestion'
      ),
  },
  [PageIdStylioHusap.PERFECT_WEEKEND_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/PartnerNoticedQuestion'
      ).then((m) => ({
        default: m.PartnerNoticedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/PartnerNoticedQuestion'
      ),
  },
  [PageIdStylioHusap.LIFESTYLE_FOCUS_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/LifestyleFocusQuestion'
      ).then((m) => ({
        default: m.LifestyleFocusQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/LifestyleFocusQuestion'
      ),
  },
  [PageIdStylioHusap.OUTFIT_NEEDS_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/OutfitNeedsQuestion'
      ).then((m) => ({
        default: m.OutfitNeedsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/questions/OutfitNeedsQuestion'),
  },
  [PageIdStylioHusap.WARDROBE_ALIGNS_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/WardrobeAlignsQuestion'
      ).then((m) => ({
        default: m.WardrobeAlignsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/questions/WardrobeAlignsQuestion'
      ),
  },
  [PageIdStylioHusap.PREPARE_FLOW_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioHusap.EMAIL_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_husap/pages/email/Email'),
  },
  [PageIdStylioHusap.EMAIL_CONSENT_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/email/EmailConsent'),
  },
  [PageIdStylioHusap.SUBSCRIPTIONS_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioHusap.CANCEL_OFFER_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/cancel-offer/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioHusap.AI_STYLIST_UPSELL_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/sub-upsell/AiStylistUpsell'
      ).then((m) => ({
        default: m.AiStylistUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/sub-upsell/AiStylistUpsell'),
  },
  [PageIdStylioHusap.FACE_STYLING_PDF_UPSELL_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/third-pdf-upsell/ThirdPdfUpsell'
      ).then((m) => ({
        default: m.ThirdPdfUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_husap/pages/third-pdf-upsell/ThirdPdfUpsell'
      ),
  },
  [PageIdStylioHusap.PROPORTIONS_PDF_UPSELL_HUSAP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_husap/pages/ProportionsPdfUpsell').then(
        (m) => ({
          default: m.ProportionsPdfUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/ProportionsPdfUpsell'),
  },
  [PageIdStylioHusap.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioHusap.DOWNLOAD_HUSAP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_husap/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_husap/pages/download-app/DownloadDefault'),
  },
}
